import API from "../../services/SchoolClassService";
import { CLASS_TYPES, WEEKDAYS } from "../common/Const";
import { minutesToTimeString, timeStringToMinutes } from "../common/Helpers";

export const getLessonIndexFromId = (lessonId) => {
  const value = String(lessonId || "");
  return value.includes("-") ? value.substring(value.lastIndexOf("-") + 1) : "";
};

export const getClassIdFromLessonId = (lessonId) => {
  const value = String(lessonId || "");
  return value.includes("-") ? value.substring(0, value.lastIndexOf("-")) : value;
};

export const buildAttendanceRoute = (classId, lessonIndex, search = "") => ({
  pathname: `/manage/class/${classId}/lesson/${lessonIndex}/attendance`,
  search,
});

const getName = person => (
  person ? `${person.firstName || ""} ${person.lastName || ""}`.trim() : ""
);

const getClassTypeName = (classTypeId) => {
  const classType = CLASS_TYPES.find(item => item.id === classTypeId);
  return classType ? classType.name : classTypeId || "";
};

const getClassType = classTypeId => CLASS_TYPES.find(item => item.id === classTypeId);

const getLessonEndTime = (lessonDetails) => {
  const classType = getClassType(lessonDetails.classTypeId);
  const startTimeMinutes = timeStringToMinutes(lessonDetails.startTime || "");

  if (!classType || startTimeMinutes === null) {
    return "";
  }

  return minutesToTimeString(startTimeMinutes + classType.length);
};

const getWeekdayName = (dayOfWeek) => {
  const weekday = WEEKDAYS.find(item => item.id === dayOfWeek);
  return weekday ? weekday.name : dayOfWeek || "";
};

const getLessonDetails = scheduledLesson => (
  scheduledLesson.lessonRegister
    ? {
      ...(scheduledLesson.defaultLessonDetails || {}),
      ...(scheduledLesson.lessonRegister.lessonDetails || {}),
    }
    : scheduledLesson.defaultLessonDetails
);

const getLessonParticipants = (scheduledLesson, students) => {
  const defaultStudents = scheduledLesson.defaultStudents || [];
  const defaultStudentIds = defaultStudents.map(student => student.id);
  const registerStudents = (scheduledLesson.lessonRegister && scheduledLesson.lessonRegister.students) || [];
  const registerOnlyStudents = registerStudents
    .filter(student => !defaultStudentIds.includes(student.id))
    .map(registerStudent => (
      students.find(student => student.id === registerStudent.id) || registerStudent
    ));

  return [
    ...defaultStudents,
    ...registerOnlyStudents,
  ];
};

export const getAttendanceLessonViewModel = ({
  schoolClasses,
  teachers,
  students,
  classStudents,
  lessonRegister,
  books,
  classId,
  lessonIndex,
}) => {
  const schoolClass = schoolClasses.find(item => item.id === classId);
  if (!schoolClass) {
    return { status: "missing-class" };
  }

  const scheduledLessons = API.generateScheduledClasses(
    schoolClass,
    lessonRegister,
    students,
    classStudents,
  );
  const scheduledLesson = scheduledLessons[Number(lessonIndex)];

  if (!scheduledLesson) {
    return { status: "missing-lesson", schoolClass };
  }

  const lessonDetails = getLessonDetails(scheduledLesson);
  const participants = getLessonParticipants(scheduledLesson, students);
  const scheduledLessonWithParticipants = {
    ...scheduledLesson,
    defaultStudents: participants,
  };
  const teacher = teachers.find(item => item.id === lessonDetails.teacherId);
  const book = books.find(item => item.id === schoolClass.bookId);
  const classTypeName = getClassTypeName(lessonDetails.classTypeId);
  const endTime = getLessonEndTime(lessonDetails);
  const weekdayName = getWeekdayName(lessonDetails.dayOfWeek);

  return {
    status: "ready",
    schoolClass,
    scheduledLesson: scheduledLessonWithParticipants,
    lessonDetails,
    endTime,
    teacherName: getName(teacher),
    classTypeName,
    weekdayName,
    bookName: book ? book.title || book.name || "" : "",
    participants,
    title: `${weekdayName}, ${lessonDetails.date} - ${classTypeName}`,
  };
};
